// Redux Utils
import { useDispatch, useSelector } from "react-redux";
import { getEmpresaInfo } from "@/features/empresa/empresaThunks";

// React and Router
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Pages
import PerfilViewEmpresaOwnerEmpresa from "@/pages/PerfilViewEmpresaOwnerEmpresa";
import PerfilEmpresa from "@/pages/PerfilEmpresa";

export default function EmpresaProfileRouter() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { infoEmpresa, isLoadingEmpresa } = useSelector(
    (state) => state.empresa
  );

  useEffect(() => {
    if (id) {
      dispatch(getEmpresaInfo({ uid: id }));
    }
  }, [dispatch, id]);

  // Show skeleton while loading or before data arrives
  if (isLoadingEmpresa || !infoEmpresa) {
    return (
      <SkeletonTheme baseColor="#1e293b" highlightColor="#334155">
        <div className="w-full max-w-5xl mx-auto relative">
          <Skeleton height={320} className="w-full rounded-b-3xl" />
        </div>
        <div className="w-full min-h-fit rounded-t-[8%] bg-gradient-to-b from-aw-bluedark from-20% via-aw-bluedark-85 via-70% to-bluedark-30 to-100% flex flex-col items-center pt-20 pb-4 -mt-20 sm:-mt-[5.5rem]">
          <div className="w-full max-w-5xl mx-auto relative">
            <div className="flex flex-col items-end sm:flex-row sm:justify-between sm:items-center">
              <div className="w-full sm:w-1/2 flex flex-row items-end sm:items-center gap-4 px-2 z-10 relative">
                <Skeleton
                  circle={true}
                  height={112}
                  width={112}
                  className="rounded-full"
                />
                <div className="flex flex-col gap-2 mb-6">
                  <Skeleton height={24} width={200} borderRadius={8} />
                  <Skeleton height={20} width={150} borderRadius={8} />
                </div>
              </div>
              <div className="flex w-full sm:w-1/2 mt-8 justify-center sm:items-center">
                <div className="flex flex-col items-center w-full sm:items-end gap-2">
                  <div className="flex flex-row justify-between gap-x-5 sm:gap-x-2">
                    <Skeleton height={40} width={120} borderRadius={8} />
                    <Skeleton height={40} width={40} borderRadius={8} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SkeletonTheme>
    );
  }

  // myself === true means the authenticated user owns this empresa
  if (infoEmpresa.myself === true) {
    return <PerfilViewEmpresaOwnerEmpresa />;
  }

  return <PerfilEmpresa />;
}
